import axios from "axios";

const api = axios.create({
  baseURL: `https://apppanterafood.com.br/DeliveryCenter/${process.env.VUE_APP_CONTRATO}/api_pantera`,
});

export default api;
